// import { currency_symbols } from "../config/config";

export const generateRandomColors = () => {
    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
};

// export const amountFormatter = (value, currencyCode) => {
//     const currencySymbol = currencyCode ? currency_symbols[currencyCode] : '';
//     return (
//         (currencySymbol || '') +
//         parseFloat(value?.toFixed(2))
//             ?.toString()
//             ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//     );
// };

export const amountFormatter = (value) => {
    if (!value) {
        return 0;
    }

    let formattedNumber;
    let suffix = '';

    switch (true) {
        case (value >= 1000 && value < 100000 || value >= -1000 && value < -100000):
            formattedNumber = value / 1000;
            suffix = 'K'
            break;

        case (value >= 100000 && value < 10000000 || value >= -100000 && value < -10000000):
            formattedNumber = value / 100000;
            suffix = 'L'
            break;

        case (value >= 10000000 || value >= -10000000):
            formattedNumber = value / 10000000;
            suffix = 'CR'
            break;

        default:
            formattedNumber = `${value}`;
    }

    return `${formattedNumber?.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}${suffix}`
}

export const formattedTableHeaders = (param) => {
    const regex = /(?=[A-Z])/;
    const splittedParam = param.split(regex);
    const firstValue = splittedParam[0].charAt(0).toUpperCase() + splittedParam[0].slice(1);
    const tableHeader = firstValue + " " + splittedParam.slice(1).join(' ');
    return tableHeader;
}
